import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeaf,
  faListCheck,
  faBoxesPacking,
  faShip,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import WhatsAppChat from "./WhatsAppChat";

import ClientStories from "./ClientStories";

const ProcessSection = () => {
  const steps = [
    {
      id: "01",
      icon: <FontAwesomeIcon icon={faLeaf} color="#22c55e" />,
      title: "Farm-Level Sourcing",
      desc: "We partner directly with trusted farmers to procure the finest, responsibly grown produce at its source.",
    },
    {
      id: "02",
      icon: <FontAwesomeIcon icon={faListCheck} color="#3b82f6" />,
      title: "Precision Sorting & Grading",
      desc: "Each batch undergoes strict quality checks and grading standards to ensure only premium products move forward.",
    },
    {
      id: "03",
      icon: <FontAwesomeIcon icon={faBoxesPacking} color="#f59e0b" />,
      title: "Advanced Hygienic Packaging",
      desc: "Using modern packaging techniques, we protect freshness, extend shelf life, and maintain export-grade standards.",
    },
    {
      id: "04",
      icon: <FontAwesomeIcon icon={faShip} color="#06b6d4" />,
      title: "Global Logistics & Shipping",
      desc: "Our efficient logistics network ensures timely, secure, and temperature-controlled delivery across international markets.",
    },
    {
      id: "05",
      icon: <FontAwesomeIcon icon={faTruck} color="#ef4444" />,
      title: "Reliable Final Delivery",
      desc: "We guarantee safe and timely delivery, ensuring products reach customers in perfect condition, every time.",
    },
  ];
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 768);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>
        From Farm to <span style={styles.highlight}>Foreign Shores</span>
      </h1>

      <p style={styles.subText}>
        Our streamlined 5-step export process ensures quality and reliability at
        every stage.
      </p>

      <div
          style={{
            ...styles.stepsWrapper,
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          {steps.map((step, index) => (
            <div
              key={step.id}
              style={{
                ...styles.stepContainer,
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              
              {/* STEP */}
              <div style={styles.step}>
                <div style={styles.circle}>
                  <span style={styles.stepNumber}>{step.id}</span>
                  <div style={styles.icon}>{step.icon}</div>
                </div>
                <h3 style={styles.title}>{step.title}</h3>
                <p style={styles.desc}>{step.desc}</p>
              </div>

              {/* CONNECTOR */}
              {index !== steps.length - 1 && (
                <div
                  style={{
                    ...styles.connector,
                    flexDirection: isMobile ? "column" : "row",
                    margin: isMobile ? "10px 0" : "0 10px",
                  }}
                >
                  <div
                    style={{
                      ...styles.line,
                      width: isMobile ? "2px" : "50px",
                      height: isMobile ? "40px" : "1px",
                    }}
                  ></div>

                  {/* Hide arrow on mobile */}
                  {!isMobile && <div style={styles.arrow}></div>}
                </div>
              )}
            </div>
          ))}
        </div>

      {/* Client Stories */}
      <div style={{ marginTop: "-20px" }}>
        <ClientStories />
      </div>
      <WhatsAppChat></WhatsAppChat>
    </div>
  );
};

const styles = {
  container: {
    color: "#fff",
    textAlign: "center",
    padding: "80px 20px",
    fontFamily: "Arial, sans-serif",
  },

  // heading: {
  //   fontSize: "40px",
  //   fontWeight: "bold",
  //   marginBottom: "10px",
  // },

  // highlight: {
  //   color: "#d4af37",
  //   fontStyle: "italic",
  // },
   heading: {
  fontSize: "clamp(39px, 5vw, 48px)",
  fontWeight: "600",
  marginBottom: "20px",
  fontFamily: "'Playfair Display', serif",
  color: "#111",
  lineHeight: "0.9",
  letterSpacing: "-0.5px",
},

highlight: {
  color: "#d4af37",
  fontStyle: "italic",
},

  subText: {
    color: "#777777",
    marginBottom: "50px",
    fontSize: "16px",
  },

  /* 🔥 RESPONSIVE WRAPPER */
  stepsWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
  },

  stepContainer: {
    display: "flex",
    alignItems: "center",
  },

  step: {
    width: "180px",
    textAlign: "center",
  },

  circle: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    border: "1px solid rgba(212,175,55,0.5)",
    margin: "0 auto 20px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  stepNumber: {
    position: "absolute",
    top: "10px",
    fontSize: "16px",
    fontWeight: "600",
    color: "#d4af37",
  },

  icon: {
    fontSize: "28px",
  },

  title: {
    fontSize: "18px",
    color: "#d4af37",
    marginBottom: "10px",
  },

  desc: {
    fontSize: "14px",
    color: "#5d5c5c",
  },

  /* CONNECTOR DESKTOP */
  connector: {
    display: "flex",
    alignItems: "center",
    margin: "0 10px",
  },

  line: {
    width: "50px",
    height: "1px",
    backgroundColor: "rgba(212,175,55,0.6)",
  },

  arrow: {
    width: 0,
    height: 0,
    borderTop: "5px solid transparent",
    borderBottom: "5px solid transparent",
    borderLeft: "8px solid rgba(212,175,55,0.9)",
  },

  /* 🔥 MOBILE FIX */
  "@media (max-width: 768px)": {
    stepsWrapper: {
      flexDirection: "column",
    },
    highlight: {
    marginTop:"30px"
  },
    stepContainer: {
      flexDirection: "column",
    },
    connector: {
      flexDirection: "column",
      margin: "10px 0",
    },
    line: {
      width: "2px",
      height: "40px",
    },
    arrow: {
      display: "none",
    },
  },
};

export default ProcessSection;